export enum ToastTypeEnum {
    Danger = 'danger',
    Success = 'success',
    Exclaim = 'exclaim',
    Waiting = 'waiting',
    Warning = 'warning',
    WarningProcess = 'warning-process',
};
